<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Port</th>
        <th class="text-sm">TX Power (dBm)</th>
        <th class="text-sm">RX Power (dBm)</th>
        <th class="text-sm">Bias Current (mA)</th>
        <th class="text-sm">Voltage (V)</th>
        <th class="text-sm">Temperature (°C)</th>
        <th class="text-sm">Uplink Power</th>
        <th class="text-sm">Status</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="8">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="uplinkInfo?.uplinkportdb">
        <tr
          v-for="port in uplinkInfo.uplinkportdb"
          :key="port.port"
        >
          <td class="text-sm">{{ port.port }}</td>
          <td class="text-sm">{{ port.tx_power }}</td>
          <td class="text-sm">{{ port.rx_power }}</td>
          <td class="text-sm">{{ port.bias_current }}</td>
          <td class="text-sm">{{ port.voltage }}</td>
          <td class="text-sm">{{ port.temperature }}</td>
          <td class="text-sm">{{ port.uplink_port_power_str }}</td>
          <td class="text-sm">
            <span
              class="badge"
              :class="{
                'bg-success text-white': port.tx_power > 0 || port.rx_power > 0,
                'bg-secondary text-white': port.tx_power === 0 && port.rx_power === 0
              }"
              style="text-transform: uppercase;"
            >
              {{ (port.tx_power > 0 || port.rx_power > 0) ? 'Active' : 'Inactive' }}
            </span>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="8" class="text-center">No uplink port data available</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'VsolUplinkTable',
  components: {
    Skalaton
  },
  props: {
    uplinkInfo: Object,
    loading: Boolean
  }
}
</script>